import React from "react";
import BasicModal from "../../../../core/BaseComponents/Modal";
import deleteImg from '../../../../../assets/images/delete.png';

function DeleteBannerImage(props) {

    return (
        <BasicModal
            popupOpen={props?.deleteBannerImagePopUp}
            bodyMessage={<>
                <img src={deleteImg} alt="approve" className="w-40px" />
                <div className="delete-banner-img mb-3">{props?.isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData ?
                    <>
                        <p>Are you sure want to Delete this Banner Image ?</p>
                        <img src={props?.isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData.bannerImage.url} alt={props?.isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData.bannerImage.id} />
                    </> :
                    props?.isBannerImaageDeletedRef.current?.deleteBannerConformationModalData?.successMessage}</div>
            </>
            }
            footer={
                props?.isBannerImaageDeletedRef.current?.isBannerImageDeletedModalData ?
                    {
                        primaryButton: {
                            buttonName: "Cancel",
                            action: props?.popupCloseHandler
                        }
                        ,
                        secondaryButton: {
                            buttonName: "Delete",
                            action: props?.deleteBannerImageHandlerApi
                        }
                    } : {
                        secondaryButton: {
                            buttonName: "OK",
                            action: props?.popupCloseHandler
                        }
                    }
            }
        />
    );
}

export default DeleteBannerImage;
